import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Card,
    Divider,
    List,
    ListItem,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Tag } from '@travelity/ui/tag';
import React from 'react';
import type { PackageSidebarItemsProps } from './types';

export const PackageRoutes = ({ product }: PackageSidebarItemsProps) => {
    const { t } = useTranslation('product');
    return (
        <Accordion disableGutters>
            <AccordionSummary>{t('Route')}</AccordionSummary>
            <AccordionDetails
                sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            >
                {product.products.map(p => (
                    <Card key={p.day_index} sx={{ position: 'relative', p: 1 }}>
                        <Typography variant="subtitle2">
                            Day {p.offset_days + 1}
                        </Typography>
                        <Divider sx={{ mt: 1 }} />
                        {p.items.map(({ id, ref, route }) => (
                            <Box key={id}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        justifyContent: 'space-between',
                                        pt: 1,
                                    }}
                                >
                                    <Typography variant="body1">
                                        {ref.name}
                                    </Typography>
                                    {route?.round_trip && (
                                        <Tag value="Round Trip" />
                                    )}
                                </Box>
                                <List>
                                    {route?.items.map(r => (
                                        <ListItem key={r.id}>
                                            {r.location.name}
                                        </ListItem>
                                    ))}
                                </List>
                                <Divider />
                            </Box>
                        ))}
                    </Card>
                ))}
            </AccordionDetails>
        </Accordion>
    );
};
